import { render, staticRenderFns } from "./musicMetaData.vue?vue&type=template&id=22c33c2c&scoped=true"
import script from "./musicMetaData.vue?vue&type=script&lang=js"
export * from "./musicMetaData.vue?vue&type=script&lang=js"
import style0 from "./musicMetaData.vue?vue&type=style&index=0&id=22c33c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c33c2c",
  null
  
)

export default component.exports